export const parseSerializedTime = (duration: string | null): number => {
  if (!duration) return 0;

  const regex = /PT(\d+H)?(\d+M)?(\d+S)?/;
  const match = regex.exec(duration);
  if (!match) return 0;

  const hours = match[1] ? Number.parseInt(match[1].replace("H", "")) : 0;
  const minutes = match[2] ? Number.parseInt(match[2].replace("M", "")) : 0;
  const seconds = match[3] ? Number.parseInt(match[3].replace("S", "")) : 0;

  return seconds + minutes * 60 + hours * 3600;
};

export const serializeTime = (seconds: number): string => {
  if (!Number.isFinite(seconds) || seconds < 0) {
    throw new Error("serializeTime: seconds must be a non-negative finite number");
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `PT${hours}H${minutes}M${secs}S`;
  }
  return `PT${minutes}M${secs}S`;
};
